const routes = [
  // Authentication routes
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { requiresAuth: false }
  },

  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },

  // Customer routes
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/customers/CustomerListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/customers/create',
    name: 'customer-create',
    component: () => import('@/views/customers/CustomerFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/customers/:id',
    name: 'customer-detail',
    component: () => import('@/views/customers/CustomerDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/customers/:id/edit',
    name: 'customer-edit',
    component: () => import('@/views/customers/CustomerFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/customers/:id/follow-ups',
    name: 'customer-follow-ups',
    component: () => import('@/views/customers/CustomerFollowUpView.vue'),
    meta: { requiresAuth: true }
  },

  // Property routes
  {
    path: '/properties',
    name: 'properties',
    component: () => import('@/views/properties/PropertyListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/properties/create',
    name: 'property-create',
    component: () => import('@/views/properties/PropertyFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/properties/:id',
    name: 'property-detail',
    component: () => import('@/views/properties/PropertyDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/properties/:id/edit',
    name: 'property-edit',
    component: () => import('@/views/properties/PropertyFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/properties/sales-control',
    name: 'sales-control',
    component: () => import('@/views/sales/SalesControlView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/properties/:id/subscribe',
    name: 'property-subscribe',
    component: () => import('@/views/subscriptions/PropertySubscriptionView.vue'),
    meta: { requiresAuth: true }
  },

  // Transaction routes
  {
    path: '/transactions',
    name: 'transactions',
    component: () => import('@/views/transactions/TransactionListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/create',
    name: 'transaction-create',
    component: () => import('@/views/transactions/TransactionFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/:id',
    name: 'transaction-detail',
    component: () => import('@/views/transactions/TransactionDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/:id/edit',
    name: 'transaction-edit',
    component: () => import('@/views/transactions/TransactionFormView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/stages',
    name: 'transaction-stages',
    component: () => import('@/views/transactions/TransactionStagesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/review',
    name: 'transaction-review',
    component: () => import('@/views/transactions/TransactionReviewView.vue'),
    meta: { requiresAuth: true }
  },

  // Report routes
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/reports/ReportsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/customers',
    name: 'customer-reports',
    component: () => import('@/views/reports/CustomerReportsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/properties',
    name: 'property-reports',
    component: () => import('@/views/reports/PropertyReportsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/transactions',
    name: 'transaction-reports',
    component: () => import('@/views/reports/TransactionReportsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/overdue',
    name: 'overdue-reports',
    component: () => import('@/views/reports/OverdueReportsView.vue'),
    meta: { requiresAuth: true }
  },

  // User routes (admin only)
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/admin/UserManagementView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // Agent review routes (admin only)
  {
    path: '/agent-review',
    name: 'agent-review',
    component: () => import('@/views/admin/AgentReviewView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // Job management routes (admin only)
  {
    path: '/job-management',
    name: 'job-management',
    component: () => import('@/views/admin/JobManagementView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // Login security audit (super admins only: demonstration_user whitelist; "demo" is legacy naming)
  {
    path: '/login-audit',
    name: 'login-audit',
    component: () => import('@/views/admin/LoginAuditView.vue'),
    meta: { requiresAuth: true, requiresDemo: true }
  },
  // Backup management routes (super admins only: demonstration_user whitelist; "demo" is legacy naming)
  {
    path: '/backup-management',
    name: 'backup-management',
    component: () => import('@/views/admin/BackupManagementView.vue'),
    meta: { requiresAuth: true }
  },
  // Customer status preview routes (super admins only: demonstration_user whitelist; "demo" is legacy naming)
  {
    path: '/customer-status-preview',
    name: 'customer-status-preview',
    component: () => import('@/views/admin/CustomerStatusPreviewView.vue'),
    meta: { requiresAuth: true }
  },
  // Property backup management routes (super admins only: demonstration_user whitelist; "demo" is legacy naming)
  {
    path: '/property-backup-management',
    name: 'property-backup-management',
    component: () => import('@/views/admin/PropertyBackupManagementView.vue'),
    meta: { requiresAuth: true }
  },

  // Settings
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: { requiresAuth: true }
  },

  // 404 route
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue')
  }
]

export default routes